import React from 'react';
import { motion } from 'framer-motion';
const decorativeItems = [
// Top area
{
  emoji: '🍅',
  top: '2%',
  left: '3%',
  size: 'text-4xl',
  rotate: 15,
  opacity: 0.12
}, {
  emoji: '🥕',
  top: '5%',
  right: '5%',
  size: 'text-3xl',
  rotate: -20,
  opacity: 0.1
}, {
  emoji: '🌿',
  top: '8%',
  left: '85%',
  size: 'text-2xl',
  rotate: 30,
  opacity: 0.08
},
// Upper-mid area
{
  emoji: '🧅',
  top: '14%',
  left: '7%',
  size: 'text-3xl',
  rotate: -10,
  opacity: 0.1
}, {
  emoji: '🍋',
  top: '16%',
  right: '8%',
  size: 'text-4xl',
  rotate: 25,
  opacity: 0.12
}, {
  emoji: '🫒',
  top: '20%',
  left: '92%',
  size: 'text-2xl',
  rotate: -15,
  opacity: 0.08
},
// Mid area
{
  emoji: '🫑',
  top: '26%',
  left: '2%',
  size: 'text-3xl',
  rotate: 20,
  opacity: 0.1
}, {
  emoji: '🥚',
  top: '30%',
  right: '4%',
  size: 'text-3xl',
  rotate: -25,
  opacity: 0.1
}, {
  emoji: '🧄',
  top: '34%',
  left: '90%',
  size: 'text-2xl',
  rotate: 10,
  opacity: 0.08
}, {
  emoji: '🌶️',
  top: '32%',
  left: '5%',
  size: 'text-2xl',
  rotate: -30,
  opacity: 0.09
},
// Center area
{
  emoji: '🥬',
  top: '40%',
  right: '3%',
  size: 'text-4xl',
  rotate: 15,
  opacity: 0.1
}, {
  emoji: '🍊',
  top: '44%',
  left: '4%',
  size: 'text-3xl',
  rotate: -20,
  opacity: 0.11
}, {
  emoji: '🥑',
  top: '48%',
  right: '6%',
  size: 'text-2xl',
  rotate: 35,
  opacity: 0.08
},
// Lower-mid area
{
  emoji: '🍅',
  top: '54%',
  left: '93%',
  size: 'text-3xl',
  rotate: -15,
  opacity: 0.1
}, {
  emoji: '🥕',
  top: '58%',
  left: '3%',
  size: 'text-2xl',
  rotate: 20,
  opacity: 0.09
}, {
  emoji: '🌿',
  top: '62%',
  right: '5%',
  size: 'text-3xl',
  rotate: -10,
  opacity: 0.1
}, {
  emoji: '🧅',
  top: '60%',
  left: '88%',
  size: 'text-2xl',
  rotate: 25,
  opacity: 0.08
},
// Lower area
{
  emoji: '🍋',
  top: '68%',
  left: '5%',
  size: 'text-3xl',
  rotate: -20,
  opacity: 0.11
}, {
  emoji: '🫑',
  top: '72%',
  right: '4%',
  size: 'text-4xl',
  rotate: 15,
  opacity: 0.1
}, {
  emoji: '🥚',
  top: '76%',
  left: '91%',
  size: 'text-2xl',
  rotate: -30,
  opacity: 0.08
},
// Bottom area
{
  emoji: '🌶️',
  top: '82%',
  left: '4%',
  size: 'text-3xl',
  rotate: 10,
  opacity: 0.1
}, {
  emoji: '🧄',
  top: '85%',
  right: '6%',
  size: 'text-2xl',
  rotate: -15,
  opacity: 0.09
}, {
  emoji: '🥬',
  top: '88%',
  left: '89%',
  size: 'text-3xl',
  rotate: 20,
  opacity: 0.1
}, {
  emoji: '🍊',
  top: '92%',
  left: '6%',
  size: 'text-4xl',
  rotate: -25,
  opacity: 0.11
}, {
  emoji: '🥑',
  top: '95%',
  right: '3%',
  size: 'text-3xl',
  rotate: 30,
  opacity: 0.09
}];
export function DecorativeBackground() {
  return <div className="fixed inset-0 w-full h-full pointer-events-none z-0 overflow-hidden" aria-hidden="true" data-id="element-25">
      {decorativeItems.map((item, index) => <motion.div key={index} initial={{
      opacity: 0
    }} animate={{
      opacity: item.opacity
    }} transition={{
      duration: 1.5,
      delay: index * 0.05
    }} className={`absolute ${item.size} select-none`} style={{
      top: item.top,
      left: item.left,
      right: item.right,
      transform: `rotate(${item.rotate}deg)`
    }} data-id="element-26">
          {item.emoji}
        </motion.div>)}
    </div>;
}